import PropTypes from "prop-types";
import { useAuthDataContext } from "components/auth";

const ExcludedForAdmin = ({ fallback = null, children }) => {
  const { hasAdminPrivileges } = useAuthDataContext();
  return hasAdminPrivileges ? fallback : children;
};

ExcludedForAdmin.propTypes = {
  /**
   * Fallback si el usuario tiene privilegios de administrador, por defecto null
   */
  fallback: PropTypes.element,
};

export default ExcludedForAdmin;
